import IFile from "@/interfaces/File";
import api from "../api";

export const filesApi = api.injectEndpoints({
  endpoints: (build) => ({
    downloadFile: build.mutation<Blob, IFile>({
      query: ({ link, name }) => ({
        url: link,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();

          // Création de l'URL du blob
          const downloadUrl = window.URL.createObjectURL(blob);
          // Création d'un lien temporaire
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = name;

          // Clic sur le lien pour télécharger le fichier
          link.click();

          // Nettoyage de l'URL du blob
          window.URL.revokeObjectURL(downloadUrl);
        },
        cache: "no-cache",
      }),
      extraOptions: {
        maxRetries: 0,
      },
    }),
  }),
  overrideExisting: true,
});

export const { useDownloadFileMutation } = filesApi;
